import type { PublishInfo } from '@services/project';
import { PublishStatus } from '@services/project/const';
import { create } from 'zustand';
import { PublishType } from './const';

interface PublishStore {
  isPublishing: boolean;
  publishDialogVisible: boolean;
  publishInfo: PublishInfo;
  baseDomain: string;
  originalSubDomain: string | null;

  setIsPublishing: (isPublishing: boolean) => void;
  setPublishDialogVisible: (visible: boolean) => void;
  setPublishInfo: (info: PublishInfo) => void;
  setBaseDomain: (domain: string) => void;
  setOriginalSubDomain: (subDomain: string | null) => void;
  reset: () => void;
}

function getDefaultPublishInfo(): PublishInfo {
  return {
  id: '',
  projectId: '',
  status: PublishStatus.NotPublished,
  type: PublishType.Free,
  subDomain: '',
  customDomain: null,
  customDomainCname: null,
  customDomainIp: null,
  customDomainRoot: false,
  customDomainPrefix: '',
  firstPublishAt: null,
  lastPublishAt: null,
  expirePublishAt: null,
  createdAt: '',
  updatedAt: '',
};
}

function getInitialState() {
  return {
  isPublishing: false,
  publishDialogVisible: false,
  publishInfo: getDefaultPublishInfo(),
  baseDomain: 'wegic.top',
  originalSubDomain: null as string | null,
};
}

export const usePublishStore = create<PublishStore>(set => ({
  ...getInitialState(),

  setIsPublishing: isPublishing => set({ isPublishing }),
  setPublishDialogVisible: visible => set({ publishDialogVisible: visible }),
  setPublishInfo: info => set({ publishInfo: info }),
  setBaseDomain: domain => set({ baseDomain: domain }),
  setOriginalSubDomain: subDomain => set({ originalSubDomain: subDomain }),
  reset: () => set(getInitialState()),
}));
